<template>
  <div v-if="showMode" class="selectLayerClass onePictureDialog smallDialog">
    <div class="headerClass">
      <span class="title">图斑选择</span>
      <span @click="close()"><a-icon type="close" style="color: aliceblue; cursor: pointer" /></span>
    </div>

    <a-divider class="divider"></a-divider>

    <div class="contentInfo">
      <div class="formInfo">
        <a-tree
          v-if="fileArr.length > 0"
          class="tree"
          :tree-data="fileArr"
          :replaceFields="replaceFields"
          :expanded-keys="expandedKeys"
          :defaultExpandAll="defaultExpandAll"
          :checkable="true"
          show-icon
          @check="treeCheck"
          @expand="onExpand"
        >
          <a-icon slot="group" type="folder"></a-icon>
          <a-icon slot="file" type="environment"></a-icon>
          <template slot="custom" slot-scope="item">
            <span style="margin-right: 20px">{{ item.dataName }}</span>
          </template>
        </a-tree>
      </div>
      <a-divider class="divider"></a-divider>
      <div class="btnsClass">
        <a-button type="link" @click="cancel" class="cancelBtn">取消</a-button>
        <a-button type="link" @click="save" class="confirmBtn">确定</a-button>
      </div>
    </div>
  </div>
</template>
  
  <script>
// import { postHeadersAction_ds } from '../../../../api/manage'
import { mapGetters } from 'vuex'
export default {
  name: 'selectLayer',
  data() {
    return {
      showMode: false,
      defaultExpandAll: true,
      fileArr: [],
      replaceFields: {
        children: 'children',
        title: 'dataName',
        key: 'bsm',
      },
      expandedKeys: [], // 展开的树节点
      checkArry: [], // 选中的节点
    }
  },
  props: {
    myCollectionTreeData:{
      type: Array,
      default: () => [],
    }
  },
  methods: {
    // 获取当前用户信息
    ...mapGetters(['userInfo']),
    // 关闭
    close() {
      this.showMode = false
    },
    // 初始化弹框信息
    setMap() {
      this.showMode = true
      this.checkArry = []
      this.fileArr = this.myCollectionTreeData.filter(e => e.name == '临时图斑数据')[0].data
      this.fileArr = this.filterEmptyDir(this.fileArr)
      // this.changeTree(this.fileArr)
      for (var item of this.fileArr) {
        this.expandedKeys.push(item.bsm)
      }
    },
    // 把空文件夹过滤
    filterEmptyDir(treeData){
      return treeData.filter(node => {
        if (node.dirType && (!node.children || node.children && node.children.length === 0)) {
          return false; 
        }
        // 递归处理子节点
        if (node.dirType && node.children && node.children.length > 0) {
          node.children = this.filterEmptyDir(node.children);
        }
        return true; // 保留节点
      });
    },
    changeTree(data) {
      data.map((node) => {
        // 给每个节点添加插槽
        node.scopedSlots = { title: 'custom' }
        if (node.dirType) {
          node.dataName = node.dirName
          if(node.details){
            node.children = [...node.children, ...node.details]
          }          
        }
        if (node.children && node.children.length > 0) {
          this.changeTree(node.children)
        }
      })
    },
    // 取消
    cancel() {
      this.close()
    },
    // 保存
    save() {
      // 把文件夹节点过滤掉
      if (this.checkArry.length > 0) {
        this.$emit('showLayers', this.checkArry)
        this.close()
      } else {
        this.$message.warning('请先进行图斑勾选!')
      }
    },
    /**
     * 文件夹选择方法
     * 展开选项
     */
    onExpand(expandedKeys) {
      console.log('展开的节点', expandedKeys)
      this.expandedKeys = expandedKeys
    },
    prpupContainer() {
      return document.querySelector('.ant-modal-body,.selectLayerClass') // ID是页面滚动的那个ID，根据自己来
    },
    // 树选择
    treeCheck(msg, node) {
      console.log('图斑选择',msg, node)
      this.checkArry = []
      if (node.checkedNodes.length > 0) {
        for (var item of node.checkedNodes) {
          if (item.data.props.wjtpye && item.data.props.dataContent) {
            this.checkArry.push(item.data.props.dataContent)
          }
        }
      }
    },
  },
}
</script>
  
<style lang="less" scoped>
/**infoview浮动面板*/
.selectLayerClass {
  position: absolute;
  top: 20%;
  width: 360px;
  max-width: 360px;
  right: 103%;
  color: #ffffff;
  backdrop-filter: blur(15px);
  .headerClass {
    width: 100%;
    height: 40px;
    opacity: 0.8;
    line-height: 40px;
    padding-top: 0 !important;
    padding-left: 10px;
    padding-right: 10px;
    display: flex;
    justify-content: space-between;
  }
  .contentInfo {
    width: 100%;
    height: 200px;
    .formInfo {
      width: 100%;
      height: 82%;
      overflow-y: auto;
      .treeSelect {
        width: 100% !important;
      }
    }
    .btnsClass {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      padding-right: 10px;
      .cancelBtn {
        color: rgba(255, 255, 255, 0.5);
      }
    }
  }
}
.infoview-left {
  right: auto;
  left: 10px;
}

.selectLayerClass input,
.selectLayerClass select,
.selectLayerClass textarea {
  color: #ffffff;
  background-color: rgba(32, 160, 255, 0.2);
  border: 1px solid #e4eaec;
  font-size: 14px;
}
/deep/ .ant-row.ant-form-item {
  margin-bottom: 0px;
  // 不要校验提示
  .ant-form-explain {
    display: none;
  }
}

/deep/ .ant-divider-horizontal {
  min-width: 94%;
  width: 94%;
  margin: auto !important;
}
</style>
  